// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".actions[data-v-591bd6ab]{gap:1rem}.actions>.action-item[data-v-591bd6ab]{width:calc(50% - .5rem)}.action-item[data-v-591bd6ab]  .v-btn__content{display:block;overflow:hidden;text-align:center;text-overflow:ellipsis;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
